import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";
import { RootState } from "../../rootReducer";

// Busqueda de usuarios asignados a la plantilla
export const findAssignedUsers = createAsyncThunk(
  "formsubmitted/findAssignedUsers",
  async ({ formId }: { formId: string | undefined }, { rejectWithValue, getState }) => {
    const state = getState() as RootState;
    const userList = state.formSubmittedSlice.userList;

    try {
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      const result = await fetch(`${api.baseURL}formsubmitted/users?form=${formId}&limit=10000`, {
        method: "GET",
        headers: headers,
      });
      const data = await result.json();
      const selected: any = [];
      data.forEach((element: any) => {
        userList.forEach((userRole: any) => {
          if (element.user.id === userRole.user.id) {
            selected.push(userRole);
          }
        });
      });
      return { assigned: data, selected: selected };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
